var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state === true || _vm.state === 'true' || _vm.state == 'yes')?_c('div',{staticClass:"greendot"}):_c('div',{staticClass:"reddot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }